<template>
	<div class="containers">
		<div class="box">
			<div class="headers">
				<span class="titles">{{ ticketMessageList[0].ticket.title }}</span>
				<button v-show="ticketMessageList[0].ticket.status !== 'C'" @click="closeTicket" class="close-ticket">
					<img  class="icon ml-2" src="../../assets/images/iconPack/charm_tick.svg" />
					بستن تیکت
				</button>
			</div>
			<div
				v-for="message in ticketMessageList"
				:key="message.id"
				:class="
					message.created_by_role_assignment === ticketMessageList[0].created_by_role_assignment
						? 'right'
						: 'left'
				"
			>
				<div
					class="right-box"
					v-if="
						message.created_by_role_assignment === ticketMessageList[0].created_by_role_assignment
					"
				>
					<div class="boxes">
						<div class="card-headers">
							<div>
								<img src="../../assets/images/iconPack/ic_round-headset-mic.svg" />
								<span class="names"
									>{{ message.created_by.first_name }} {{ message.created_by.last_name }}</span
								>
							</div>
							<div class="d-flex">
								<date-picker
									v-model="message.datetime_created"
									type="datetime"
									format="YYYY-MM-DD"
									display-format="jYYYY-jMM-jDD"
									:timezone="true"
									:disabled="true"
								/>
								<img src="../../assets/images/iconPack/uil_calender.svg" />
							</div>
						</div>
						<hr />
						<div class="contents">
							{{ message.body }}
						</div>
					</div>
				</div>
				<div class="left-box" v-else>
					<div class="boxes">
						<div class="card-headers">
							<div>
								<img src="../../assets/images/iconPack/ic_round-headset-mic-yellow.svg" />
								<span class="names"
									>{{ message.created_by.first_name }} {{ message.created_by.last_name }}</span
								>
							</div>
							<div class="d-flex">
								<date-picker
									v-model="message.datetime_created"
									type="datetime"
									format="YYYY-MM-DD"
									display-format="jYYYY-jMM-jDD"
									:timezone="true"
									:disabled="true"
								/>
								<img src="../../assets/images/iconPack/uil_calender-yellow.svg" />
							</div>
						</div>
						<hr />
						<div class="contents">
							{{ message.body }}
						</div>
					</div>
				</div>
			</div>
			<div class="send-answer">
				<div class="header">متن پاسخ</div>
				<textarea :disabled="ticketMessageList[0].ticket.status === 'C'" v-model="descVal" rows="4" class="text-area"></textarea>
			</div>
			<button  @click="sendTicket" :disabled="disableSendTicket" class="send-ticket">
				<img class="icon" src="../../assets/images/iconPack/tabler_send.svg" />
				ارسال پاسخ
			</button>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
            lastParam:'',
			ticketMessageList: [],
            descVal:null
		};
	},
	computed: {
		disableSendTicket() {
			if (this.descVal === null || this.descVal === '') {
				return true;
			} else {
				return false;
			}
		},
	},
	mounted() {
		this.getTicketMessage();
	},
	methods: {
		async getTicketMessage() {
			const url = window.location.href;
			this.lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.TICKET_MESSAGE + '?ticket=' + this.lastParam + '&p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.ticketMessageList = res.data;
				(this.ticketMessageList);
			}
		},
        async closeTicket() {
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.TICKET_EDIT + this.lastParam + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{ status: 'C' },
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'تیکت با موفقیت بسته شد!',
				});
				setTimeout(() => {
						this.$router.push({ name: 'ticketList' });
					}, 2000);
			}
		},
        async sendTicket() {
			const resp = await this.$ApiServiceLayer.post(
					this.$PATH.RELATIVE_PATH.MULTI.TICKET_MESSAGE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
					this.$PATH.SERVICE_NAME.AUTH,
					{ ticket: this.lastParam, body: this.descVal },
				);
				if (resp.status === 201) {
					this.$notify({
						group: 'tc',
						type: 'success',
						text: 'تیکت شما با موفقیت ارسال شد.',
					});
                    this.descVal = null
					this.getTicketMessage()
				}
		},
	},
};
</script>
<style lang="scss" scoped>
.containers {
	padding: 24px;
    
	.box {
		background: #fff;
		padding: 24px;
        border-radius: 8px;
		.headers {
			display: flex;
			justify-content: space-between;
			margin-bottom: 50px;
			.titles {
				font-size: 18px;
			}
			.close-ticket {
				border: 1px solid #16c98d;
				color: #16c98d;
				background: #fff;
				padding: 6px;
				border-radius: 8px;
				font-size: 14px;
			}
		}
		.right {
			display: flex;
			justify-content: flex-start;
			width: 100%;
		}
		.left {
			display: flex;
			justify-content: flex-end;
			width: 100%;
		}

		.contents {
			font-size: 12px;
            overflow-wrap: break-word;
		}
	}
	.send-answer {
		margin-top: 48px;
		.header {
			font-size: 14px;
			margin-bottom: 12px;
		}
		.text-area {
			width: 100%;
			border: 1px solid #cedae2;
			border-radius: 8px;
            padding: 10px;
		}
	}
    .send-ticket {
		background: #285595;
		color: #fff;
		border-radius: 8px;
		padding: 4px 10px;
		border: none;
        margin-top: 24px;
		&:disabled {
			background: #c4c4c4;
		}
		.icon {
			width: 20px;
		}
	}
}
</style>
<style lang="scss">
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	font-size: 12px;
	background: none !important;
	border: none !important;
	width: 75px;
	font-family: 'IRANYekanfa' !important;
}
.left-box {
	background: #fffbe8;
	border-radius: 8px;
	border: 1px solid #cfdae2;
	padding: 18px;
	width: 50%;
	margin-top: 20px;
	.card-headers {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.names {
		font-size: 12px;
		color: #929292;
		margin-right: 10px;
	}
	.vpd-input-group input {
		color: #929292;
	}
	.contents {
		font-size: 12px;
	}
}
.right-box {
	background: #f2f5fa;
	border-radius: 8px;
	border: 1px solid #cfdae2;
	padding: 18px;
	width: 50%;
    margin-top: 20px;
	.card-headers {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.names {
		font-size: 12px;
		color: #6b92c8;
		margin-right: 10px;
	}
	.vpd-input-group input {
		color: #6b92c8 !important;
	}
}
</style>
